import React from 'react';
import "./navlink.css";
import { Link } from "react-router-dom";

const Navlink = (props) => {
    return ( 
        <>
        <li>
        <Link className={props.s} to={props.link}>
            {props.name}
        </Link>
        </li>
        </>
     );
}
 
export default Navlink;